//import { ROUTES } from '../../lib/route-links';

const Subscribe = () => {


    return (
        <section className='w-full lg:pt-20 pt-10 lg:pb-20 pb-10 lg:px-20 px-5'>
            <div className="w-full subscribe-bg bg-contain lg:bg-bottom-center bg-[center_15%] rounded-3xl bg-primary-dark py-20 lg:py-[100px] lg:px-10 px-5 flex flex-col items-center justify-center">
                <h6 className='lg:w-1/2 w-full text-white text-[18px] mb-8 font-[600]'>WE ARE GLOBAL</h6>
                <h1 className='lg:w-2/5 w-full text-white text-center lg:text-[40px] text-[30px] mx-auto mb-8'>Engage, Contribute & Grow Our Community</h1>
               {/* <a href={ROUTES.SIGNUP} className='lg:w-[250px] w-full rounded-lg border border-[#D1D1D1] py-4 px-8 text-[#D1D1D1] lg:text-[15px] text-[13px] font-semibold'>Get Started For Free</a> */}
            </div>
        </section>
    );
};

export default Subscribe;